import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Box, Button, Container, createTheme, CssBaseline, Divider, Grid, Paper, TextField, ThemeProvider, Typography } from '@mui/material'
import { getByRegistroClaveProyecto, getByRegistroReferencia } from '../../../../database/dbRegistroGeneral';
import { TextareaCustom } from '../../../modules/ui/TextareaCustom';

export const Sina2025Trabajos = () => {

    const queryParameters = new URLSearchParams(window.location.search)
    const ref = queryParameters.get("id")
    const edit = queryParameters.get("edit"); 
    //? edit > 'academia' = revision academica, 'usuario' = participante registrado


    const [record, setRecord] = useState({});
    const [works, setWorks] = useState([]);

    const [isDataLoaded, setisDataLoaded] = useState(false);

    const [isReview, setIsReview] = useState(false);
    const [isUpdate, setIsUpdate] = useState(false);


    useEffect(async() => {

        switch (edit) {
            case 'academia':
                setIsReview(true);
                break;
            case 'usuario':
                setIsUpdate(true);
                break;
        }

        const { data } = await getByRegistroReferencia(ref);
        const recordTmp = data[0];

        const infoAdicional = JSON.parse(recordTmp.infoAdicional);
        setWorks(infoAdicional.trabajos);

        const recordToShow = { ...recordTmp, infoAdicional: infoAdicional };
        setRecord(recordToShow);

        setisDataLoaded(true);
    }, [ ref ])

    // useEffect(() => {

    // }, [ record ])
    
    

    return (
        <ThemeProvider theme={createTheme()}>
        <Container component="main">
        <CssBaseline />
        {
            isDataLoaded &&
            <Paper elevation={ 4 } sx={{ m: 2, p: 2 }}>
                <Grid container spacing={ 2 }>
                    <Grid item xs={ 6 }>
                        <Typography fontSize={ 24 } fontWeight={ 900 }>
                            { `${ record.partApellidoPaterno } ${ record.partApellidoMaterno } ${ record.partNombres }` }
                        </Typography>
                        <Typography color='blue'>{ record.partCorreo }</Typography>
                        <Typography>{ ref }</Typography>
                    </Grid>
                    <Grid item xs={ 6 }>
                        <Typography>Modalidad: <strong>{ record.infoAdicional.modalidad }</strong></Typography>
                        <Typography>Ocupación/puesto: <strong>{ record.tipoRegistro }</strong></Typography>
                        {
                            record.tipoRegistroDocURL !== ''
                            ? <a href={ record.tipoRegistroDocURL } target='_blank'>Consultar documento</a>
                            : <></>
                        }
                    </Grid>

                    <Grid item xs={ 12 }><Divider sx={{ my: 1 }}/></Grid>

                    <Grid item xs={ 12 }>
                        <Typography>Total de trabajos: <strong>{ works.length }</strong></Typography>
                        {
                            works.map(work =>
                                <Box key={ work.id } my={ 1 } p={ 1 } sx={{ border: '1px solid lightblue' }}>
                                    <Typography fontStyle='italic' fontSize={ 16 }>{ work.title }</Typography>
                                    <Box 
                                        display={ record.infoAdicional.modalidad === 'Participante' ? 'flex' : 'none' } 
                                        flexDirection='column'
                                    >
                                        <Typography fontSize={ 10 } align='center'>Nombre del archivo:</Typography>
                                        <Typography fontSize={ 10 } align='center'>
                                            <strong>{ work.url.slice( work.url.lastIndexOf('/') + 1) }</strong>
                                        </Typography>
                                        <a href={ work.url } download="MyExampleDoc" target='_blank'>
                                            <Button fullWidth variant='contained' size='small'>Descargar</Button>
                                        </a>
                                    </Box>
                                    
                                    <Divider sx={{ my: 1 }}/>
                                    
                                    <Box
                                    // Solo para el comite evaluador
                                    >
                                        <TextareaCustom 
                                            name={ work.id }
                                            label='Comentarios al participante'
                                            parentCallback={ (data) => console.log(data) }
                                        />
                                    </Box>
                                </Box>
                            )
                        }
                    </Grid>


                </Grid>
            </Paper>
        }

        </Container>
        </ThemeProvider>
    )
}
